module.exports = __webpack_public_path__ + "static/img/comment.0149618.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/HomePage/img/comment.png
// module id = 0g2d
// module chunks = 1